import React from 'react';
import './custom-tile.scss';
import { Link } from 'react-router-dom';
import { ACTION_TYPE_DETAILS, getActionLink } from '../../../CPMapping';
// const section = {
//   "sectionType": "CUSTOM_TILE",
//   "position": 0,
//   "sectionData": [
//     {
//       "customTileId": 21,
//       "name": "The festive shop",
//       "pageName": "homepage",
//       "isShowName": false,
//       "position": 0,
//       "tileRow": [
//         {
//           "customTileRowId": 17,
//           "customTileId": 21,
//           "position": 1,
//           "tileColumn": [
//             {
//               "customTileColumnId": 15,
//               "customTileRowId": 17,
//               "imageUrl": "https://ik.imagekit.io/iwcam3r8ka/custom-tiles/202008/6a9e067f-5910-4efb-b8c8-9fcf137f640a.jpg",
//               "actionType": "noAction",
//               "height": 300,
//               "width": 300,
//               "actionValue": "-",
//               "position": 1
//             },
//             {
//               "customTileColumnId": 16,
//               "customTileRowId": 17,
//               "imageUrl": "https://ik.imagekit.io/iwcam3r8ka/custom-tiles/202008/c8df0b15-5775-449c-8da8-e87d67ffbc5f.jpg",
//               "actionType": "noAction",
//               "height": 300,
//               "width": 300,
//               "actionValue": "-",
//               "position": 2
//             }
//           ]
//         },
//         {
//           "customTileRowId": 18,
//           "customTileId": 21,
//           "position": 2,
//           "tileColumn": [
//             {
//               "customTileColumnId": 17,
//               "customTileRowId": 18,
//               "imageUrl": "https://ik.imagekit.io/iwcam3r8ka/custom-tiles/202008/be56d2a6-aa93-4980-83e4-e13235f75f57.jpg",
//               "actionType": "noAction",
//               "height": 150,
//               "width": 600,
//               "actionValue": "-",
//               "position": 1
//             }
//           ]
//         }
//       ]
//     }
//   ]
// };

const CustomTile = props => {
  // console.log('Props: ', props);
  // const ct = section.sectionData[0];
  const { ct } = props;
  const isExternalLink = link => link.indexOf('http') === 0;
  const setImageType = column => {
    if (column.actionType !== ACTION_TYPE_DETAILS.NO_ACTION.type) {
      if (
        column.actionType === ACTION_TYPE_DETAILS.LINK.type &&
        isExternalLink(column.actionValue)
      ) {
        return (
          <a
            href={getActionLink(column)}
            target="_blank"
            className="custom-tile--action"
          >
            <img src={column.imageUrl} alt={column.imageAltText || ct.name} />
          </a>
        );
      } else {
        return (
          <Link to={getActionLink(column)} className="custom-tile--action">
            <img src={column.imageUrl} alt={column.imageAltText || ct.name} />
          </Link>
        );
      }
    } else {
      return (
        <img
          src={column.imageUrl}
          alt={column.imageAltText || ct.name}
          className="custom-tile--action"
        />
      );
    }
  };
  return (
    <div className="custom-tile">
      {ct.isShowName && <div className="custom-tile--name">{ct.name}</div>}
      {ct.tileRow.map((row, ri) => {
        const colWidth = `col-${Math.floor(100 / row.tileColumn.length)}`;
        return (
          <div className="custom-tile--row" key={`r${ri + 1}`}>
            {row.tileColumn.map((column, ci) => {
              return (
                <div
                  className={`custom-tile--column ${colWidth}`}
                  key={`r${ri + 1}-c${ci + 1}`}
                >
                  {setImageType(column)}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default CustomTile;
